import { useEffect } from "react";
import { Box, Typography, Button, Stack, IconButton } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import CloseIcon from "@mui/icons-material/Close";

const Notification = ({
  type = "success",
  message = "",
  buttons = [],
  onClose,
  autoClose = true,
  duration = 3000,
}) => {
  const isSuccess = type === "success";

  useEffect(() => {
    if (autoClose && onClose) {
      const timer = setTimeout(() => {
        onClose();
      }, duration);
      return () => clearTimeout(timer);
    }
  }, [autoClose, duration, onClose]);

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 2,
        background: isSuccess ? "#e6f9f0" : "#fdeaea",
        border: `1.5px solid ${isSuccess ? "#22c55e" : "#ef4444"}`,
        borderRadius: 2,
        px: 3,
        py: 2,
        minWidth: 320,
        maxWidth: 400,
        boxShadow: "0 4px 16px 0 rgba(30,41,59,0.10)",
        position: "fixed", // Change to fixed
        top: 24, // Add top position
        right: 24, // Add right position
        zIndex: 1400, // Ensure it's above other elements
        transition: "box-shadow 0.2s",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", mr: 1 }}>
        {isSuccess ? (
          <CheckCircleIcon sx={{ color: "#22c55e", fontSize: 32 }} />
        ) : (
          <ErrorIcon sx={{ color: "#ef4444", fontSize: 32 }} />
        )}
      </Box>
      <Box sx={{ flex: 1, pr: 4 }}>
        <Typography
          sx={{
            color: isSuccess ? "#15803d" : "#b91c1c",
            fontWeight: 700,
            fontSize: "1em", // smaller font
            letterSpacing: 0.1,
            mb: buttons.length ? 1 : 0,
            textAlign: "left",
          }}
        >
          {message}
        </Typography>
        {buttons.length > 0 && (
          <Stack direction="row" spacing={1}>
            {buttons.map((btn, idx) => (
              <Button
                key={idx}
                variant="contained"
                size="small"
                color={isSuccess ? "success" : "error"}
                onClick={btn.onClick}
                sx={{ fontWeight: 600, textTransform: "none" }}
              >
                {btn.label}
              </Button>
            ))}
          </Stack>
        )}
      </Box>
      {onClose && (
        <IconButton
          size="small"
          onClick={onClose}
          sx={{
            position: "absolute",
            top: 8,
            right: 8,
            color: "#b91c1c",
            background: "rgba(255,255,255,0.7)",
            "&:hover": {
              background: "#fee2e2",
              color: "#ef4444",
            },
            transition: "all 0.2s",
          }}
          aria-label="close"
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      )}
    </Box>
  );
};

export default Notification;
